import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseImage: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2.5H18C19.933 2.5 21.5 4.067 21.5 6V18C21.5 19.933 19.933 21.5 18 21.5H6C4.067 21.5 2.5 19.933 2.5 18V6C2.5 4.067 4.067 2.5 6 2.5ZM6 4C4.89543 4 4 4.89543 4 6V15.9393L5.76256 14.1768C6.44598 13.4934 7.55402 13.4934 8.23744 14.1768L10 15.9393L15.7626 10.1768C16.446 9.49336 17.554 9.49336 18.2374 10.1768L20 11.9393V6C20 4.89543 19.1046 4 18 4H6ZM6 20C4.91493 20 4.03168 19.1359 4.00083 18.0583C4.01085 18.0493 4.02069 18.04 4.03033 18.0303L6.82322 15.2374C6.92085 15.1398 7.07914 15.1398 7.17678 15.2374L10 18.0607L16.8232 11.2374C16.9209 11.1398 17.0791 11.1398 17.1768 11.2374L19.9697 14.0303C19.9796 14.0402 19.9897 14.0498 20 14.059V18C20 19.1046 19.1046 20 18 20H6ZM10 11.5C11.3807 11.5 12.5 10.3807 12.5 9C12.5 7.61929 11.3807 6.5 10 6.5C8.61929 6.5 7.5 7.61929 7.5 9C7.5 10.3807 8.61929 11.5 10 11.5ZM11 9C11 9.55228 10.5523 10 10 10C9.44772 10 9 9.55228 9 9C9 8.44772 9.44772 8 10 8C10.5523 8 11 8.44772 11 9Z"
        fill={color}
      />
    </svg>
  );
};
